import { addGiftToCart } from 'backend/cart-actions.web.js';
import wixEcomFrontend from "wix-ecom-frontend";
import { getProductVariants } from 'backend/getProductVariants.jsw';
import { formFactor } from "wix-window-frontend"

export async function expandClaimYourGift(gift) {
    $w('#section2').expand();

    // Initialize product options
    initializeProductOptions(gift.giftProduct.productOptions);

    const cleanedDescription = gift.giftProduct.description.replace(/<[^>]*>?/gm, '');
    let truncatedDescription;
    let truncatedTitle;
    let truncatedProductName;

    if (formFactor === "Mobile") {
        truncatedDescription = cleanedDescription.slice(0, 53);
        truncatedTitle = gift.giftTitle.slice(0, 23);
        truncatedProductName = gift.giftProduct.name.slice(0, 23);
    } else {
        truncatedDescription = cleanedDescription.slice(0, 113);
        truncatedTitle = gift.giftTitle.slice(0, 41);
        truncatedProductName = gift.giftProduct.name.slice(0, 41);
    }

    if (cleanedDescription.length > truncatedDescription.length) {
        truncatedDescription += '...';
    }
    if (gift.giftTitle.length > truncatedTitle.length) {
        truncatedTitle += '...';
    }
    if (gift.giftProduct.name.length > truncatedProductName.length) {
        truncatedProductName += '...';
    }

    $w('#giftTitle').text = `Claim your ${truncatedTitle}!`;
    $w('#productName').text = truncatedProductName;
    $w('#productDescription').text = truncatedDescription;
    $w('#formattedDiscountedPrice').text = gift.giftProduct.formattedDiscountedPrice

    const fullPriceText = gift.giftProduct.formattedPrice;
    if (fullPriceText === "€0.00" || fullPriceText === null || fullPriceText === "0") {
        $w('#fullPrice').hide();
    } else {
        $w('#fullPrice').text = fullPriceText;
        $w('#fullPrice').show();
    }

    $w('#productImg').src = gift.giftProduct.mainMedia;

    $w('#addToCart').onClick(async () => {


        if (!validateSelections()) {
            $w('#addToCart').enable();
            return;
        }

        try {
            $w('#loading').expand();
            $w('#addToCart').disable();
            $w('#addToCart').label = "";

            const { variantId, options } = await getSelectedVariantId(gift.giftProduct.productId);
            const addedGift = await addGiftToCart(gift.giftProduct.productId, variantId, options);

            if (addedGift.ss) {
                wixEcomFrontend.refreshCart().then(() => {
                    $w('#section2').collapse();
                    $w('#addToCart').label = "Add to cart";
                    $w('#loading').collapse();
                });
            } else {
                handleErr();
            }
        } catch (error) {
            console.error("Error in addToCart:", error);
            handleErr();
        }
    });
}

function initializeProductOptions(productOptions) {
    $w('#dropDown1').collapse();
    $w('#dropDown2').collapse();
    $w('#colors').collapse();
    $w('#colorTitle').collapse();
    $w('#selectedColor').collapse();

    if (!productOptions || Object.keys(productOptions).length === 0) {
        $w('#productDescription').expand();
        return;
    }
    $w('#productDescription').collapse();

    // console.log("product Options", productOptions);

    let dropdownCount = 0;

    Object.entries(productOptions).forEach(([key, option]) => {
        if (option.optionType === 'color') {
            initializeColorOption(option);
            $w('#colors').expand();
            $w('#colorTitle').expand();
        } else if (option.optionType === 'drop_down') {
            initializeDropdownOption(option, dropdownCount);
            $w(dropdownCount === 0 ? '#dropDown1' : '#dropDown2').expand();
            dropdownCount++;
        }
    });
}

function initializeColorOption(option) {
    $w('#colorTitle').text = option.name;
    const colorRepeater = $w('#colors');

    const colorChoices = option.choices.map((choice, index) => ({
        _id: `c${index}`,
        backgroundColor: hexToRgb(choice.value),
        title: choice.description,
        selected: false
    }));

    colorRepeater.data = colorChoices;
    colorRepeater.forEachItem(($item, itemData, index) => {
        const box = $item('#box1');
        box.style.backgroundColor = itemData.backgroundColor;
        box.style.borderWidth = "0";
        box.style.borderColor = "#000000";
        box.onClick(() => handleColorSelection(index));
    });
}

function hexToRgb(hex) {
    hex = hex.replace('#', '');

    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgb(${r}, ${g}, ${b})`;
}

function initializeDropdownOption(option, index) {
    const dropdown = $w(index === 0 ? '#dropDown1' : '#dropDown2');
    dropdown.label = option.name;

    const choices = option.choices.map(choice => ({
        label: choice.description,
        value: choice.value
    }));

    dropdown.options = choices;
}

function handleColorSelection(selectedIndex) {
    const colorRepeater = $w('#colors');
    const currentData = colorRepeater.data;

    currentData.forEach(item => item.selected = false);
    currentData[selectedIndex].selected = true;
    colorRepeater.data = currentData;

    colorRepeater.forEachItem(($item, itemData, index) => {
        const box = $item('#box1');
        if (index === selectedIndex) {
            box.style.borderWidth = "3px";
            box.style.borderColor = "#000000";
            $w('#selectedColor').text = `Selected color: ${itemData.title}`;
            $w('#selectedColor').expand();
        } else {
            box.style.borderWidth = "1px";
        }
    });
}

async function getSelectedVariantId(productId, shouldShowError = true) {
    try {
        const choices = {};

        if (!$w('#dropDown1').collapsed && $w('#dropDown1').value) {
            choices[$w('#dropDown1').label] = $w('#dropDown1').value;
        }
        if (!$w('#dropDown2').collapsed && $w('#dropDown2').value) {
            choices[$w('#dropDown2').label] = $w('#dropDown2').value;
        }

        if (!$w('#colors').collapsed) {
            const colorData = $w('#colors').data;
            const selectedColor = colorData.find(item => item.selected);
            if (selectedColor) {
                choices[$w('#colorTitle').text] = selectedColor.title;
            }
        }

        try {
            const variants = await getProductVariants(productId, { choices });
            console.log("Variants returned:", variants);

            if (!variants || variants.length === 0) {
                // Return null variantId but include selected options
                return {
                    variantId: null,
                    options: choices
                };
            }

            const selectedVariant = variants[0];
            console.log("Selected variant:", selectedVariant);

            if (selectedVariant.variant &&
                (selectedVariant.variant.inStock === false ||
                    (selectedVariant.variant.trackQuantity && selectedVariant.variant.quantity === 0))) {
                if (shouldShowError) {
                    displayErrorMessage("Selected variant is out of stock");
                }
                throw new Error("No stock");
            }

            return {
                variantId: selectedVariant._id,
                options: choices
            };

        } catch (error) {
            if (error.message.includes("Cannot filter by choices")) {
                console.log("Variant not managed, using options only");
                return {
                    variantId: "00000000-0000-0000-0000-000000000000",
                    options: choices
                };
            }
            throw error;
        }
    } catch (error) {
        console.error("Error getting variant ID:", error);
        throw error;
    }
}

function validateSelections() {
    let isValid = true;
    let missingElements = [];

    if (!$w('#dropDown1').collapsed && !$w('#dropDown1').value) {
        isValid = false;
        missingElements.push($w('#dropDown1').label);
    }
    if (!$w('#dropDown2').collapsed && !$w('#dropDown2').value) {
        isValid = false;
        missingElements.push($w('#dropDown2').label);
    }

    if (!$w('#colors').collapsed) {
        const colorData = $w('#colors').data;
        const hasSelectedColor = colorData.some(item => item.selected);
        if (!hasSelectedColor) {
            isValid = false;
            missingElements.push($w('#colorTitle').text);
        }
    }

    if (!isValid) {
        displayErrorMessage("Missing required selection");
        return false;
    }

    return true;
}

function displayErrorMessage(message) {
    $w('#errMsg').text = message;
    $w('#errMsg').expand();

    setTimeout(() => {
        $w('#errMsg').collapse();
        $w('#errMsg').text = "Error adding your gift, please try again";
    }, 3000);
}

function handleErr() {
    $w('#errMsg').expand();
    setTimeout(() => {
        $w('#errMsg').collapse();
        $w('#addToCart').label = "Add to cart";
    }, 3000);
    $w('#addToCart').enable();
    $w('#loading').collapse();
}